@if(viewOVTForm){
<form [formGroup]="overtimeForm" class="overtime-form" (ngSubmit)="SaveRequest()">

  <h2>Overtime Request</h2>

    <div class="form-row">

  <!-- Employee Name -->
  <div class="form-group">
    <label>Employee Name</label>
    <input type="text" formControlName="employeeName" style="width:350px;"/>
  </div>
    <div class="form-group">
      <label>Date of Overtime</label>
      <input type="date" formControlName="fecha" />
    </div>
  <!-- Date -->
    </div>
  <div class="form-row">

     <div class="form-group" style="width: 30%;">
      <label>Start Time</label>
      <input type="time" formControlName="startTime" />
    </div>

    <div class="form-group" style="width: 30%;">
      <label>End Time</label>
      <input type="time" formControlName="endTime"  />
    </div>
        <div class="form-group" style="width: 30%;">
      <label>Total Hours</label>
      <input type="number" formControlName="totalHours" readonly />
    </div>
  </div>

  <!-- Time -->
  <!-- <div class="form-row">


  </div> -->

  <!-- Overtime Type -->
  <div class="form-group">
    <label>Overtime Type</label>
    <select formControlName="overtimeType">
      <option value="">Select type</option>
      <option *ngFor="let type of overtimeTypes" [value]="type.value">
        {{ type.label }}
      </option>
    </select>
  </div>

  <!-- Reason -->
  <div class="form-group">
    <label>Reason for Overtime</label>
    <textarea rows="2" formControlName="reason"></textarea>
  </div>

  <!-- Manager Approval (read-only) -->
  <div class="form-group readonly">
    <label>Manager Approval</label>
    <input type="text" value="Pending" disabled />
  </div>

  <!-- Actions -->
  <div class="actions">
    <button type="submit" [disabled]="overtimeForm.invalid">
      Submit Request
    </button>
    <button type="button" class="secondary" (click)="close();">
      Cancel
    </button>
  </div>

</form>
}
<!-- Overtime Requests List -->
 <form class="overtime-form">
<div class="overtime-list" [ngClass]="viewOVTForm ? 'ovt-list-single' : ''">

  <h3>My Overtime Requests</h3>

  <div class="list-container">

    @for (ot of overtimeRequests; track ot.id) {
      <div
        class="overtime-item"
        (click)="openOvertimeDetails(ot)"
      >

        <div class="left">
          <div class="date">{{ ot.fecha | date:'dd MMM yyyy' }}</div>
          <div class="hours">{{ ot.totalHours }} hrs</div>
        </div>

        <div class="right">

          @if (ot.approved === '1') {
            <span class="status approved">
              <span class="material-symbols-outlined">check_circle</span>
              Approved
            </span>
          }

          @else if (ot.rejected === '1') {
            <span class="status rejected">
              <span class="material-symbols-outlined">cancel</span>
              Rejected
            </span>
          }

          @else {
            <span class="status pending">
              <span class="material-symbols-outlined">schedule</span>
              Pending
            </span>
          }

        </div>
      </div>
    }

    @if (overtimeRequests.length === 0) {
      <div class="empty">
        No overtime requests yet.
      </div>
    }

  </div>
</div>
</form>
